import AppFooter from './app-footer.vue';

export default AppFooter;
